import {defineStore} from 'pinia';
import {useContextStore} from './contextStore';
import commonFunction from '@/commons/commonFunction';
import WebSocketEvent from '@/commons/wildcards/constants/WebSocketEvent';
import fileApi from '@/apis/fl/fileApi';
import StorageFileType from '@/commons/wildcards/constants/StorageFileType';
import {MSConstant} from '@/commons/wildcards';
import {msFormat} from '@/commons/msFormat';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil.js';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';
import {showAlert} from '@/commons/globalMessage';
import {$vfm} from 'vue-final-modal';

export const useGlobalSocketStore = defineStore('GlobalSocket', {
  state: () => {
    return {mapSession: {}, mapTimeInterval: {}, connectedSocket: false, sessionId: null};
  },
  actions: {
    updateConnectedSocket(sessionId) {
      this.connectedSocket = true;
      this.sessionId = sessionId;
    },
    


    /**
     * Admin đã thay đổi vai trò của bạn, bạn cần load lại vai trò
     * @param {*} args
     * nvxuan 04.10.2023
     */
    [WebSocketEvent.ChangeRoleOfSysUser]: async function (args) {
      const {user_id, exe_user_id, affectUserIds} = JSON.parse(args);
      const context = useContextStore();
      const curUserID = context?.CurUserId;
      const payload = {
        databaseId: context?.CurDatabaseId,
        tenantId: context?.context?.Context?.TenantId,
        userId: curUserID,
      };

      if ((user_id && curUserID == user_id) || (affectUserIds && affectUserIds.contains(curUserID))) {
        const token = await context.getToken(payload);

        // Nếu chính mình thay đổi vai trò của mình thì reload luôn không cần thông báo
        if (exe_user_id == curUserID) {
          location.reload();
        } else {
          // show thông báo
          showAlert('Quản trị dữ liệu đã thay đổi vai trò quyền hạn của bạn.', 'Quyền hạn thay đổi').then(() => {
            location.reload();
          });
        }
      }
    },

    /**
     * Thông báo bắn về
     * @param {*} sender
     * @param {*} res
     * tvtoan 2.6.2023
     */
    notification: args => {
      const messageData = JSON.parse(args);
      // 5: khóa sổ
      if (messageData.type == 5) {
      }
    },
  },
});
